// extracted by mini-css-extract-plugin
export var article = "doc-post-module--article--dc716";
export var body = "doc-post-module--body--2df3a";
export var container = "doc-post-module--container--66e25";
export var mobileModeTracker = "doc-post-module--mobileModeTracker--b3064";
export var release = "doc-post-module--release--5e4a7";
export var sidebarHidden = "doc-post-module--sidebarHidden--bec29";